export const TreeSelectViewMode = {
  onlyPages: 'onlyPages',
  allNodeDefs: 'allNodeDefs',
}
